import React, { useState, useEffect } from "react"
import { Row, Col, Button } from "reactstrap"
import Switch from "react-switch"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPAlert from "../../../framework/widgets/DPAlert"
import { Numeric, DecimalValidation, Text } from "../../../framework/validators/TextValidation" // Textbox input validations
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "framework/validators/SearchColumn"
import ReactPaginate from 'react-paginate';
import { getAllLocations } from "./ProductController"
import { is } from "date-fns/locale"

const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Yes
    </div>
  )
}

const ProductSupplierContent = ({ DataRow, Disabled, menuCode, setarRowSupp, handleClearStatus, SetLoadingAlert, SetLoadingAlerttitle }) => {

  const [postsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)


  useEffect(() => {
    setCurrentPage(1)
  }, [handleClearStatus])


  /**
      * @description This function is used to change the value of perticular field in perticular row.
      * @param {string} value - value of the row.
      * @param {string} id - id of the row.
      * @param {string} element - element of the row.
   */

  const changeRowValueChanges = (value, id, element) => {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setarRowSupp(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  /**
      * @description This function is used to change the value of complete row.
      * @param {JSON} row - row of the table.
      * @param {string} id - id of the row.
   */

  function handleObjectChange(row, id) {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    setarRowSupp(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }

  const [SupplierColumns, setSupplierColumns] = useState([])
  const [LocationColumns, setLocationColumns] = useState([])

  ///** Functions for Supplier Details add and delete */
  function handleAddRowNestedSupp() {
    const modifiedRows = [...DataRow]

    const hasEmptyRow = modifiedRows.find(x => x.locationDisable === false || x.supplierDisable === false);

    if (hasEmptyRow) {

      //update cuurent page if the page is last page
      if (modifiedRows.length % postsPerPage != 0) {
        setCurrentPage(Math.floor(modifiedRows.length / postsPerPage) + 1)
      }

      return false;
    }

    modifiedRows.push({
      "id": modifiedRows.length + 1,
      "AfterMarkup": 0,
      "Markup": 0,
      "Cost": 0,
      "Discount": 0,
      "selling": 0,
      "code": "",
      "Loccode": "",
      "state": false,
      "desc": "",
      "locationDisable": false,
      "supplierDisable": true
    })

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setarRowSupp(idModification)
  }

  function handleRemoveRowSupp(id) {

    const modifiedRows = [...DataRow]
    const index = modifiedRows.findIndex(row => row.id === id)
    modifiedRows.splice(index, 1)

    if (modifiedRows.length === 0) {
      modifiedRows.push({
        "id": 1,
        "AfterMarkup": 0,
        "Markup": 0,
        "Cost": 0,
        "Discount": 0,
        "selling": 0,
        "code": "",
        "Loccode": "",
        "state": false,
        "desc": "",
        "locationDisable": false,
        "supplierDisable": true
      })
    }

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setarRowSupp(idModification)

  }
  ///** Functions for Price Details add and delete */

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };


  const dublicateSupplierLocationWise = async (CurrentRow) => {

    if (CurrentRow.code === "" || CurrentRow.Loccode === "") {
      return;
    }

    try {
      SetLoadingAlert(true)
      SetLoadingAlerttitle("Please wait while duplicating supplier location wise")
      const locations = await getAllLocations();
      let proSuppliers = [...DataRow];
      const currentRowCode = CurrentRow.code;

      // Set all other suppliers to false if CurrentRow.state is false
      if (CurrentRow.state) {
        proSuppliers.forEach((supplier) => {
          if (supplier.code == currentRowCode) {
            supplier.state = true;
          } else {
            supplier.state = false;
          }
        });
      }

      // Create a map of existing suppliers for quick lookup
      const existingSuppliersMap = new Map(
        proSuppliers.map((supplier) => [`${supplier.Loccode}_${supplier.code}`, supplier])
      );

      locations.forEach((location) => {
        const locationKey = `${location.value}_${currentRowCode}`;

        if (existingSuppliersMap.has(locationKey)) {
          // If supplier exists, update its state based on CurrentRow.state
          const existingSupplier = existingSuppliersMap.get(locationKey);
          existingSupplier.state = CurrentRow.state;
        } else {
          // Add a new supplier if it does not exist
          proSuppliers.push({
            id: proSuppliers.length + 1,
            AfterMarkup: CurrentRow.AfterMarkup ?? 0,
            Markup: CurrentRow.Markup ?? 0,
            Cost: CurrentRow.Cost ?? 0,
            Discount: CurrentRow.Discount ?? 0,
            selling: CurrentRow.selling ?? 0,
            code: currentRowCode,
            Loccode: location.value,
            state: CurrentRow.state,
            desc: CurrentRow.desc,
            locationDisable: true,
            supplierDisable: true,
          });
        }
      });

      //order the suppliers by location

      proSuppliers = proSuppliers.sort((a, b) => {
        if (a.code < b.code) {
          return -1;
        }
        if (a.code > b.code) {
          return 1;
        }
        return 0;
      });



      // Update the state with the modified suppliers array
      setarRowSupp(proSuppliers);
    } catch (error) {
      console.error(error);
    } finally {
      SetLoadingAlert(false)
    }

  };




  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost)

  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table style={{ fontSize: "11px" }} id={"SupplierDet"}>
            <thead className="table-light">
              <tr>
                <th>Location </th>
                <th></th>
                <th>Code </th>
                <th></th>
                <th>Description </th>
                <th style={{ textAlign: "right" }}>Invoice Price </th>
                <th style={{ textAlign: "right" }}>Discount(%) </th>
                <th style={{ textAlign: "right" }}>Cost Price </th>
                <th style={{ textAlign: "right" }}>Markup(%) </th>
                <th style={{ textAlign: "right" }}>Selling Price </th>
                <th style={{ textAlign: "center" }}>Is Default</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody disabled={true}>


              {currentPosts.map((formRow, key) => (
                <TableRow
                  FormRow={formRow}
                  Key={key}
                  Disabled={Disabled}
                  menuCode={menuCode}
                  changeRowValueChanges={changeRowValueChanges}
                  handleObjectChange={handleObjectChange}
                  DataRow={DataRow}
                  RemoveRow={handleRemoveRowSupp}
                  LocationColumns={LocationColumns}
                  SupplierColumns={SupplierColumns}
                  dublicateSupplierLocationWise={dublicateSupplierLocationWise}
                />
              ))}

            </tbody>
          </table>
          <Button
            disabled={Disabled}
            onClick={() => {
              handleAddRowNestedSupp()
            }}
            color="success"
            className="mt-1"
            size="sm"
          >
            <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={Math.ceil(DataRow.length / postsPerPage)}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            forcePage={currentPage - 1}
            renderOnZeroPageCount={null}
            activeClassName={'active'}
            activeLinkClassName={'page-link'}
            containerClassName={'pagination justify-content-center pagination-sm'}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}
export default ProductSupplierContent

const TableRow = ({ FormRow, Key, RemoveRow, Disabled, menuCode, LocationColumns,
  SupplierColumns, changeRowValueChanges, handleObjectChange, DataRow, dublicateSupplierLocationWise }) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [state, SetState] = useState(FormRow.state != 1 ? false : true)


  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [modal_xlargeSup, setmodal_xlargeSup] = useState(false)

  const [DataTablesSupp, SetDatatableSupp] = useState([])


  const [Datatablesub, SetDatatablesub] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')


  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    LocCodeSearch(row.LOC_CODE)
    setmodal_xlarge(!modal_xlarge)
  }

  function LocCodeSearch(value) {

    if (value == "") return

    let currentRow = FormRow

    fetch(`${ApiURL}Locations/SearchCode/${value}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${authToken}`
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          const newArray = responseData.data[0]

          currentRow.Loccode = newArray.code
          currentRow.locationDisable = true
          currentRow.supplierDisable = false
          handleObjectChange(currentRow, FormRow.id)

        }
        else {
          currentRow.Loccode = ""
          currentRow.locationDisable = false
          currentRow.supplierDisable = true
          handleObjectChange(currentRow, FormRow.id)
        }
      })

  }


  function SupplierCodeSearch(value) {
    var currentRow = FormRow
    if (value == "") {


      currentRow.code = ""
      currentRow.desc = ""
      handleObjectChange(currentRow, FormRow.id)
      return
    }

    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    fetch(`${ApiURL}Supplier/Grid/${value}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${authToken}`
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          const newArray = responseData.data[0]

          currentRow.code = newArray.code
          currentRow.desc = newArray.name
          currentRow.locationDisable = true
          currentRow.supplierDisable = true
          handleObjectChange(currentRow, FormRow.id)

        }
        else {
          currentRow.code = ""
          currentRow.desc = ""
          currentRow.locationDisable = currentRow.locationDisable ? true : false
          currentRow.supplierDisable = false
          handleObjectChange(currentRow, FormRow.id)
        }
      })

  }

  
  const Hed_SelectRowSearchSup = (e, row, isSelect, rowIndex) => {

    if (CodeValidationSup(row.SM_CODE, "txtSuppliercode" + Key, FormRow.Loccode, "txtSupLoccode" + Key)) {

      SupplierCodeSearch(row.SM_CODE)

    }
    else {
      setAlertDescription("Code already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
      var currentRow = FormRow
      currentRow.code = ""
      currentRow.desc = ""
      handleObjectChange(currentRow, FormRow.id)

    }

    setmodal_xlargeSup(!modal_xlargeSup)
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }
  function tog_xlargeSup() {
    setmodal_xlargeSup(!modal_xlargeSup)
    removeBodyCss()
  }
  async function clickSearch() {
    tog_xlargeSup()
  }
  async function clickLocSearch() {
    tog_xlarge()
  }


  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  //* Code Validation from repeating*/
  const CodeValidation = (state, row) => {


    const isSupplierDefaultWithAllLocation = DataRow.filter(x => x.state === true && x.Loccode === "").length > 0;
    if (isSupplierDefaultWithAllLocation && state === true) {
      return false
    }

    const isSupplierDefaultWithLocation = DataRow.filter(x => x.state === true && x.Loccode === row.Loccode && x.id != row.id).length > 0;
    if (isSupplierDefaultWithLocation && state === true) {
      return false
    }

    // const isDefaultSupplier = DataRow.filter(x => x.state === true).length > 0;
    // if (isDefaultSupplier && state === true) {
    //   return false
    // }

    return true

  }


  const CodeValidationSup = (code, id) => {

    const supplierFilter = DataRow.filter(x => x.code === code && x.id != id)

    if (supplierFilter.length > 0) {

      // const filterbyEmptyLocation = supplierFilter.filter(x => x.Loccode === "")

      // if (filterbyEmptyLocation.length > 0) {
      //   return false
      // }

      // check if there is another record with same location
      const filterbyLocation = supplierFilter.filter(x => x.Loccode === FormRow.Loccode)

      if (filterbyLocation.length > 0) {
        return false
      }

      //check if this supplier is used with another location
      // const usedByAnotherLocation = supplierFilter.filter(x => x.Loccode === FormRow.Loccode && x.code === code)

      // if (usedByAnotherLocation.length > 0) {
      //   return false
      // }

      //used by anotehr all location

      // const usedByAnotherAllLocation = supplierFilter.filter(x => x.Loccode === "" && x.code === code)
      // if (usedByAnotherAllLocation.length > 0) {
      //   return false
      // }

      //check if used by anotehr location which is not empty and this location is empty
      // const usedByAnotherLocationEmpty = supplierFilter.filter(x => x.Loccode === "" && FormRow.Loccode !== "" && x.code === code)

      // if (usedByAnotherLocationEmpty.length > 0) {
      //   return false
      // }

      //check if used by another location which is not equal to this location and this location is empty

      // const usedByAnotherLocationNotEqual = supplierFilter.filter(x => x.Loccode !== "" && FormRow.Loccode == "" && x.code === code)

      // if (usedByAnotherLocationNotEqual.length > 0) {
      //   return false
      // }

    }

    return true

  }
  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td style={{ width: "100px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtSupLoccode" + Key}
              value={FormRow.Loccode}
              onChange={e => {
                changeRowValueChanges(e.target.value, FormRow.id, "Loccode")
              }}
              onBlur={e => {
                LocCodeSearch(e.target.value)
              }}
              disabled={Disabled ? true : FormRow.locationDisable}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "30px" }}>
        <Row className="mb-0">
          <Col md="12">
            <Button
              disabled={Disabled ? true : FormRow.locationDisable}
              outline
              color="success"
              id={"btnLocSearch" + Key}
              onClick={clickLocSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "140px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="15"
              id={"txtSuppliercode" + Key}
              value={FormRow.code}
              onChange={e => {

                let valsupplier = Text(
                  e.target,
                  30,
                  true,
                  true,
                  "any",
                  true
                )

                changeRowValueChanges(valsupplier, FormRow.id, "code")
              }}
              onBlur={e => {

                if (CodeValidationSup(e.target.value, FormRow.id)) {
                  SupplierCodeSearch(e.target.value)
                } else {
                  setAlertDescription("Code already used")
                  setAlertConfirmOption(4)
                  setsweetAlertShow(true)
                  var currentRow = FormRow
                  currentRow.code = ""
                  currentRow.desc = ""
                  handleObjectChange(currentRow, FormRow.id)
                }

              }}
              disabled={Disabled ? true : FormRow.supplierDisable}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "30px" }}>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              disabled={Disabled ? true : FormRow.supplierDisable}
              color="success"
              id={"btnSearch" + Key}
              onClick={clickSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>

      </td>
      <td style={{ width: "200px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              disabled={true}
              id={"txtsupdesc" + Key}
              value={FormRow.desc}
              onChange={e => {
                changeRowValueChanges(e.target.value, FormRow.id, "desc")
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>

      <td style={{ width: "100px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              defaultValue="0.0"
              textAlign="right"
              id={"txtSelling" + Key}
              value={FormRow.selling}
              disabled={Disabled}
              onChange={e => {
                let Selling = Numeric(e.target, 8, 2, false)
                if (Selling == "") {
                  changeRowValueChanges("0.0", FormRow.id, "selling")
                }
                else {
                  changeRowValueChanges(Selling, FormRow.id, "selling")
                }
              }}
              onBlur={e => {
                let Selling = DecimalValidation(e.target.value, 0, true, 2)
                if (Selling == "") {
                  changeRowValueChanges("0.0", FormRow.id, "selling")
                }
                else {
                  changeRowValueChanges(DecimalValidation(e.target.value, 0, true, 2), FormRow.id, "selling")

                  if (parseFloat(FormRow.Discount) > 0) {
                    let CostPrice = DecimalValidation((Selling - (Selling * parseFloat(FormRow.Discount) / 100)), 0, true, 2);
                    changeRowValueChanges(CostPrice, FormRow.id, "cost")
                  }
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              defaultValue="0.0"
              textAlign="right"
              id={"txtDiscount" + Key}
              value={FormRow.Discount}
              disabled={Disabled}
              onChange={e => {
                let valMaxDis = Numeric(e.target, 8, 2, false)
                if (valMaxDis == "") {
                  changeRowValueChanges("0.0", FormRow.id, "Discount")
                }
                else {
                  changeRowValueChanges(valMaxDis, FormRow.id, "Discount")
                }
              }}
              onBlur={e => {
                let valMaxDis = DecimalValidation(e.target.value)
                if (valMaxDis == "") {
                  changeRowValueChanges("0.0", FormRow.id, "Discount")
                }
                else {
                  if (valMaxDis <= 100) {
                    changeRowValueChanges(DecimalValidation(e.target.value), FormRow.id, "Discount")
                    if (parseFloat(FormRow.selling) > 0) {
                      let CostPrice = DecimalValidation((parseFloat(FormRow.selling) - (parseFloat(FormRow.selling) * valMaxDis / 100)), 0, true, 2);
                      changeRowValueChanges(CostPrice, FormRow.id, "Cost")
                    }
                  } else {
                    changeRowValueChanges("0.0", FormRow.id, "Discount")
                  }
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px", textAlign: "right" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              defaultValue="0.0"
              textAlign="right"
              id={"txtCost" + Key}
              value={FormRow.Cost}
              disabled={Disabled}
              onChange={e => {
                let valCost = Numeric(e.target, 8, 2, false)
                if (valCost == "") {
                  changeRowValueChanges("0.0", FormRow.id, "Cost")
                }
                else {
                  changeRowValueChanges(valCost, FormRow.id, "Cost")
                }
              }}
              onBlur={e => {
                let valCost = DecimalValidation(e.target.value, 0, true, 2)
                if (valCost == "") {
                  changeRowValueChanges("0.0", FormRow.id, "Cost")
                }
                else {
                  changeRowValueChanges(DecimalValidation(e.target.value, 0, true, 2), FormRow.id, "Cost")
                  if (parseFloat(FormRow.Markup) > 0) {
                    let selling = DecimalValidation((parseFloat(valCost) + (parseFloat(valCost) * parseFloat(FormRow.Markup) / 100)), 0, true, 2)
                    changeRowValueChanges(selling, FormRow.id, "AfterMarkup")
                  }
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px", textAlign: "right" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              defaultValue="0.0"
              textAlign="right"
              id={"txtMarkup" + Key}
              value={FormRow.Markup}
              disabled={Disabled}
              onChange={e => {
                let valMarkup = Numeric(e.target, 8, 2, false)
                if (valMarkup == "") {
                  changeRowValueChanges("0.0", FormRow.id, "Markup")
                }
                else {
                  changeRowValueChanges(valMarkup, FormRow.id, "Markup")
                }
              }}
              onBlur={e => {
                let valMarkup = DecimalValidation(e.target.value, 0, true, 2)
                if (valMarkup == "") {
                  changeRowValueChanges("0.0", FormRow.id, "Markup")
                }
                else {
                  if (valMarkup <= 100) {
                    changeRowValueChanges(DecimalValidation(e.target.value), FormRow.id, "Markup")
                  } else {
                    changeRowValueChanges("0.0", FormRow.id, "Markup")
                  }
                  if (parseFloat(FormRow.Cost) > 0) {
                    let selling = DecimalValidation(((parseFloat(FormRow.Cost)) + ((parseFloat(FormRow.Cost)) * valMarkup / 100)), 0, true, 2)
                    changeRowValueChanges(selling, FormRow.id, "AfterMarkup")
                  }
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px", textAlign: "right" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              disabled={Disabled}
              textAlign="right"
              id={"txtAfterMarkup" + Key}
              value={FormRow.AfterMarkup}
              onChange={e => {
                let valAfterMarkup = Numeric(e.target, 8, 2, false)
                if (valAfterMarkup == "") {
                  changeRowValueChanges("0.0", FormRow.id, "AfterMarkup")
                }
                else {
                  changeRowValueChanges(valAfterMarkup, FormRow.id, "AfterMarkup")
                }
              }}
              onBlur={e => {
                let valAfterMarkup = DecimalValidation(e.target.value, 0, true, 2)
                if (valAfterMarkup == "") {
                  changeRowValueChanges("0.0", FormRow.id, "AfterMarkup")
                }
                else {
                  changeRowValueChanges(DecimalValidation(e.target.value, 0, true, 2), FormRow.id, "AfterMarkup")
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "80px", margin: "auto", textAlign: "center" }}>
        <Row className="mb-0">
          <Col md="12" >
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              onColor="#626ed4"
              height={23}
              handleDiameter={15}
              onChange={e => {
                if (CodeValidation(e, FormRow)) {
                  changeRowValueChanges(e, FormRow.id, "state")
                } else {
                  setAlertDescription("Can not add more than one default supplier for same location")
                  setAlertConfirmOption(4)
                  setsweetAlertShow(true)
                }
              }}

              disabled={Disabled}
              checked={FormRow.state}
              id={"swdatereq" + Key}
            />
          </Col>
        </Row>
      </td>
      <td>


        <Button
          outline
          disabled={Disabled}
          color="danger"
          id={"btnDelete" + Key}
          onClick={e => {
            RemoveRow(FormRow.id)
          }}
          size="sm"
        >
          <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
        </Button>


        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={LocationColumns}
          defaultSorted={defaultSorted}
          mainTitle={"Location Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={modal_xlarge}
          toggle={tog_xlarge}
          getSelect={Hed_SelectRowSearch}
          APIURL={ApiURL}
          URLPath={"LOCATION"}
          MenuCode={menuCode}
          KeyVal={'LOC'}
          searchBy={'LOC_CODE'}
          FilterStr={groupFilter}
        />



        <DPSearchBoxDynamic
          searchData={DataTablesSupp}
          columns={SupplierColumns}
          defaultSorted={defaultSorted}
          mainTitle="Supplier Search"
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={modal_xlargeSup}
          toggle={tog_xlargeSup}
          getSelect={Hed_SelectRowSearchSup}
          APIURL={ApiURL}
          URLPath={"SUPPLIER"}
          MenuCode={menuCode}
          KeyVal={'PRO'}
          searchBy={'SM_CODE'}
          FilterStr={groupFilter}
        />
        <DPAlert
          confirm_both={sweetAlertShow}
          title={"Product Master !"}
          description={AlertDescription}
          showCancel={false}
          btnColor={"success"}
          cancelColor={"danger"}
          onConfirm={() => {
            setsweetAlertShow(false)

          }}
          btnYes={"OK"}
        />

      </td>
      <td>
        <Button
          outline
          disabled={Disabled}
          color="success"
          onClick={e => {
            dublicateSupplierLocationWise(FormRow)
          }}
          size="sm"
        >
          <i className="mdi mdi-recycle" style={{ fontSize: "12px" }}></i>
        </Button>
      </td>
    </tr>
  )
}
